/* =========================

  FV

============================ */
import styled from "styled-components";
import {break_point_sp} from "../../../Styled/mixin";


/* -------------------------

  component

---------------------------- */
function Btn( props ) {
  return (
    <Styled className="p-result__btn c-result__btn l-box__btn" color_back={(props.color_back)?props.color_back:"#ec0000"} color_font={(props.color_font)?props.color_font:"#ffffff"} color_arrow={(props.color_arrow)?props.color_arrow:"#ec0000"} >
      <a href={props.href} target="_blank" rel="strict-origin-when-cross-origin">{props.children}</a>
    </Styled>
  );
}

export default Btn;

/* -------------------------

  styled

---------------------------- */

/*
ALL
---------------------------- */
const Styled = styled.p`
  a{
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 24px;
    color: ${(props)=>props.color_font};
    padding: 10px 3em;
    background: ${(props)=>props.color_back};
    border-radius: 50px;
    position: relative;
    &::before{
      content: " ";
      display: block;
      width: 1em;
      height: 1em;
      background: #ffffff;
      border-radius: 50%;
      position: absolute;
      transform: translateY(50%);
      bottom: 50%;
      right: 1em;
    }
    &::after{
      content: " ";
      display: block;
      width: 0.3em;
      height: 0.3em;
      border-top: solid 2px ${(props)=>props.color_arrow};
      border-right: solid 2px ${(props)=>props.color_arrow};
      position: absolute;
      transform: translateY(50%) rotate(45deg);
      bottom: 49%;
      right: 1.4em;
    }
  }
	@media ${break_point_sp} {
    a{
      padding: 15px 4%;
      border-radius: 100px;
      font-size: calc((40/750)*100vw);
    }
	}
`;
